import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './form.styl'

export default class FormLoader extends Component {
  static propTypes = {
    isPerson: PropTypes.bool,
    isOrganization: PropTypes.bool,
    isEvent: PropTypes.bool,
    isTemplate: PropTypes.bool,
    itemsCount: PropTypes.number,
  }

  render() {
    const { isPerson, itemsCount, isEvent, isOrganization, isTemplate } = this.props
    const items = []
    const isDefault = !isPerson && !isEvent && !isOrganization && !isTemplate

    for (let i = 0; i < itemsCount; i++) {
      items.push(<div key={i}><div className={styles.loaderInput} /></div>)
    }

    return (
      <div className={styles.loader}>
        {isDefault && <div className="row">
          <div className="col-xs-6" style={{ overflow: 'hidden' }}>
            {items}
          </div>
          <div className="col-xs-6" style={{ overflow: 'hidden' }}>
            {items}
          </div>
        </div>}
        {isPerson && <div className="row">
          <div className="col-xs-12 text--right">
            <div className={styles.buttonPlaceholder} />
          </div>
          <div className="col-xs-6">
            <div className="row">
              <div className="col-xs-6">
                <div className={styles.contentPlaceholder} />
              </div>
              <div className="col-xs-6" style={{ overflow: 'hidden' }}>
                {items}
              </div>
            </div>
          </div>
          <div className="col-xs-6">
            <div className={styles.contentPlaceholder}>
              <div className={styles.content} />
              <div className={styles.content} />
              <div className={styles.content} />
            </div>
          </div>
        </div>}
        {isOrganization && <div className="row">
          <div className="col-xs-12 text--right">
            <div className={styles.buttonPlaceholder} />
          </div>
          <div className="col-xs-6">
            <div className="row">
              <div className="col-xs-12" style={{ overflow: 'hidden' }}>
                {items}
              </div>
            </div>
          </div>
          <div className="col-xs-6">
            <div className={styles.contentPlaceholder}>
              <div className={styles.content} />
              <div className={styles.content} />
              <div className={styles.content} />
            </div>
          </div>
        </div>}
        {isEvent && <div className="row">
          <div className="col-xs-12 text--right">
            <div className={styles.buttonPlaceholder} />
          </div>
          <div className="col-xs-6">
            <div className="row">
              <div className="col-xs-12">
                <div className={styles.buttonPlaceholder} />
              </div>
              <div className="col-xs-12">
                {items}
              </div>
            </div>
          </div>
          <div className="col-xs-6">
            <div className={styles.contentPlaceholder}>
              <div className={styles.content} />
              <div className={styles.content} />
              <div className={styles.content} />
            </div>
          </div>
        </div>}
        {isTemplate && <div className="row">
          <div className="col-xs-12 text--right">
            <div className={styles.buttonPlaceholder} />
          </div>
          <div className="col-xs-6">
            {items}
          </div>
          <div className="col-xs-6">
            <div className={styles.contentPlaceholder}>
              <div className={styles.content} />
              <div className={styles.content} />
              <div className={styles.content} />
            </div>
          </div>
        </div>}
      </div>
    )
  }
}
